import Login from './Login.json';
import SideBar from './SideBar.json';
import Navbar from './Navbar.json';
import Employee from './Employee.json';
import ChangePassword from './ChangePassword.json';
import Enterprise from './Enterprise.json';
import NotFound from './NotFound.json';
import JobTitle from './JobTitle.json';
import Generic from './Generic.json';
import Department from './Department.json';
import DefinitionEnterprise from './DefinitionEnterprise.json';
import DefinitionDepartment from './DefinitionDepartment.json';
import DefinitionJobTitle from './DefinitionJobTitle.json';
import DefinitionCourse from './DefinitionCourse.json';
import Dialog from './Dialog.json';
import Table from './Table.json';
import EmployeeAssess from './EmployeeAssess.json';
import DevelopmentPlan from './DevelopmentPlan.json';
import MyCourses from './MyCourses.json';
import Dashboard from './Dashboard.json';
import Courses from './Courses.json';
import CourseDetails from './CourseDetails.json';
import Dates from './Dates.json';
import EditCourse from './EditCourse.json';
import EditCoursePost from './EditCoursePost.json';
import Evaluation from './Evaluation.json';
import Achievements from './Achievements.json';
import Attendance from './Attendance.json';
import employees_reports from './employees_reports.json';
import employees_courses_report from './employees_courses_report.json';
import progress_indicator from './progress_indicator.json';
import courses_reports from './courses_reports.json';
import course_employees_report from './course_employees_report.json';
import course_test from './course_test.json';
import courses_lessons from './courses_lessons.json';
import Roles from './Roles.json';
import role_permissions from './role_permissions.json';
import history_reports from './history_reports.json';
import history_employee_report from './history_employee_report.json';
import history_courses_report from './history_courses_report.json';
import history_course_detail from './history_course_detail.json';
import EditCourseSessions from './EditCourseSessions.json';
import SessionsReport from './SessionsReport.json';
import Settings from './Settings.json';

export default {
  Login,
  SideBar,
  Navbar,
  Employee,
  ChangePassword,
  Enterprise,
  NotFound,
  Department,
  DefinitionEnterprise,
  DefinitionDepartment,
  DefinitionJobTitle,
  DefinitionCourse,
  Dialog,
  JobTitle,
  Generic,
  EmployeeAssess,
  DevelopmentPlan,
  Table,
  MyCourses,
  Dashboard,
  Courses,
  CourseDetails,
  EditCourse,
  EditCoursePost,
  Dates,
  Evaluation,
  Achievements,
  Attendance,
  employees_reports,
  employees_courses_report,
  progress_indicator,
  courses_reports,
  course_employees_report,
  course_test,
  courses_lessons,
  Roles,
  role_permissions,
  history_reports,
  history_employee_report,
  history_courses_report,
  history_course_detail,
  EditCourseSessions,
  SessionsReport,
  Settings,
};
